import ButtonLink from "PFComponents/button/button_link";
import { Icon } from "PFComponents/icon";
import { Tooltip } from "PFComponents/tooltip";
import { Id } from "PFCore/types";
import { KnownFiltersV2 } from "PFTypes/filters_v2";
import { useTranslation } from "react-i18next";

type ViewInBookingModuleButtonType = {
  openAllocateManually?: boolean;
  activityId?: Id;
  workforceMemberId?: Id;
  className?: string;
  classes?: {
    root?: string;
    inner?: string;
    hover?: string;
  };
};

const ViewInBookingModuleButton = ({
  openAllocateManually,
  className,
  activityId,
  workforceMemberId
}: ViewInBookingModuleButtonType) => {
  const { t } = useTranslation("activities");

  const searchParams = new URLSearchParams({
    openAllocateManually: openAllocateManually ? "true" : "",
    activityId: activityId?.toString() || "",
    [KnownFiltersV2.WorkforceMemberId]: workforceMemberId?.toString() || ""
  });

  return (
    <Tooltip content={t("show.shortlist.viewInBookingModule")}>
      <ButtonLink
        href={`/booking?${searchParams.toString()}`}
        kind="secondary"
        rootClassName={className}
        title={t("show.shortlist.viewInBookingModule")}
      >
        <Icon name="booking" size="sm" />
      </ButtonLink>
    </Tooltip>
  );
};

export default ViewInBookingModuleButton;
